<script>
    import { AisQueryRuleCustomData } from 'vue-instantsearch';
    import { RouteUtils } from "../../functions/route-utils";

    export default {
        name:"QueryRuleCustomDataExtended",
        extends: AisQueryRuleCustomData,
        mixins: [],
        data: function () {
            return {
                redirectFound: false
            }
        },
        methods: {
            transformItems: function (items, { results }) {
                if (!this.redirectFound) {
                    const match = results?.renderingContent?.redirect;

                    if (match && match.url) {
                        this.redirectFound = true;
                        window.location.href = `${RouteUtils.ensureNoTrailingSlash(match.url)}`;
                    }
                }

                return [];
            }
        },
        async created() {

        },
        destroyed() {

        }
    };
</script>